export default "__VITE_ASSET__kKBuUUZE__"